import theme from "theme";

export const NextStepBoxCheckboxContainerBackgroundColor = {
  ok: theme.custom.palette.green.main,
  pending: theme.custom.palette.yellow.main,
  empty: theme.custom.palette.softWhite.main,
  failed: theme.custom.palette.red.main,
} as const;

export const NextStepBoxCheckboxColor = {
  ok: theme.custom.palette.green.main,
  pending: theme.custom.palette.yellow.main,
  empty: theme.custom.palette.softWhite.main,
  failed: theme.custom.palette.red.main,
} as const;

export const NextStepBoxCheckboxBackgroundColor = {
  ok: theme.custom.palette.green.main,
  pending: theme.custom.palette.softWhite.main,
  empty: theme.custom.palette.softWhite.main,
  failed: theme.custom.palette.softWhite.main,
} as const;

export const NextStepBoxIconTextTextSize = {
  ok: "12px",
  pending: "8px",
  empty: "10px",
  failed: "10px",
} as const;

export const NextStepBoxCircleSrcImageName = {
  ok: "ok",
  pending: "in_progress",
  empty: "circle-thin",
  failed: "red_fail",
} as const;

export const NextStepBoxIconTextValue = {
  ok: "DONE",
  pending: "IN PROGRESS",
  empty: "",
  failed: "FAILED",
} as const;
